// extracted by mini-css-extract-plugin
export default {"env-chart-box":"EnvChart_env-chart-box__U8OOH"};